import { OTHERGOODS_EXPENSES_FAILED, OTHERGOODS_EXPENSES_REQUEST, OTHERGOODS_EXPENSES_SUCCESS } from "app/redux/actions/Master/Expenses/OtherGoodsExpenses/constant";


const INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null
    }
};

export const otherGoodsExpensesReducer = function (state = INIT_STATE, action) {
    switch (action?.type) {
        case OTHERGOODS_EXPENSES_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null
                }
            }
        case OTHERGOODS_EXPENSES_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null
                }
            }
        case OTHERGOODS_EXPENSES_FAILED:
            const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message
                }
            }
        default:
            return state;
    }
};